"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * RoRo API
 * This documents RoRo APIs for handling public facing App needs
 *
 * The version of the OpenAPI document: 0.0.43
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
var runtime_1 = require("../runtime");
var _1 = require("./");
/**
* @export
* @enum {string}
*/
var BriefRideDetailVehicleTypeEnum;
(function (BriefRideDetailVehicleTypeEnum) {
    BriefRideDetailVehicleTypeEnum["Scooter"] = "Scooter";
    BriefRideDetailVehicleTypeEnum["Bike"] = "Bike";
})(BriefRideDetailVehicleTypeEnum = exports.BriefRideDetailVehicleTypeEnum || (exports.BriefRideDetailVehicleTypeEnum = {}));
function BriefRideDetailFromJSON(json) {
    return BriefRideDetailFromJSONTyped(json, false);
}
exports.BriefRideDetailFromJSON = BriefRideDetailFromJSON;
function BriefRideDetailFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'id': json['id'],
        'vehicleType': !runtime_1.exists(json, 'vehicleType') ? undefined : json['vehicleType'],
        'startTime': !runtime_1.exists(json, 'startTime') ? undefined : (new Date(json['startTime'])),
        'duration': !runtime_1.exists(json, 'duration') ? undefined : json['duration'],
        'totalPrice': !runtime_1.exists(json, 'totalPrice') ? undefined : json['totalPrice'],
        'startLocation': !runtime_1.exists(json, 'startLocation') ? undefined : _1.LocationFromJSON(json['startLocation']),
        'endLocation': !runtime_1.exists(json, 'endLocation') ? undefined : _1.LocationFromJSON(json['endLocation']),
    };
}
exports.BriefRideDetailFromJSONTyped = BriefRideDetailFromJSONTyped;
function BriefRideDetailToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'id': value.id,
        'vehicleType': value.vehicleType,
        'startTime': value.startTime === undefined ? undefined : (value.startTime.toISOString()),
        'duration': value.duration,
        'totalPrice': value.totalPrice,
        'startLocation': _1.LocationToJSON(value.startLocation),
        'endLocation': _1.LocationToJSON(value.endLocation),
    };
}
exports.BriefRideDetailToJSON = BriefRideDetailToJSON;
